export const getLoading = (state) => state.statistics.base.list_history.loading;
export const getError = (state) =>  state.statistics.base.list_history.error;
export const getData = (state) =>  state.statistics.base.list_history.data;
